import { Modal, Form, Input, Button, Select, App, Table, Descriptions, Space, Typography, Divider, Spin, Alert, Row, Tabs, Tooltip } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { _T } from '../../base-react/src/Localization';
var Api = apis.Api;
var CompetitionSource = models.competitions.CompetitionsSource;
var ClassesSource = models.classes.ClassesSource;
var ClassTeamSource = models.teams.ClassTeamSource;
var UserCompetitionItem = models.users.UserCompetitionItem;
var TeamItem = models.teams.TeamItem;
var Stream = hooks.streams.Stream;
import { apis, hooks, models } from '@vote4dance/judging-sdk';
import { CheckOutlined, DeleteOutlined, DownloadOutlined, FileAddOutlined, UploadOutlined, UserAddOutlined, WarningOutlined } from '@ant-design/icons';
import { ButtonConfirm } from '../../base-react/components/ButtonConfirm';
import { getAssetUrl } from '../../base-react/scripts/cdn';
import { useCompetition } from '../../base-react/hooks/Competition';
import dayjs from 'dayjs';
import { useUserSettings } from '../../base-react/hooks/Storage';
const { Title, Text } = Typography;
export const ExternalAPI = (props) => {
    const [inputCompetition] = useCompetition(props.competition_id);
    if ((inputCompetition === null || inputCompetition === void 0 ? void 0 : inputCompetition.competition_federation) !== 'WDSF') {
        return null;
    }
    return React.createElement(ExternalAPIModal, { ...props });
};
const ExternalAPIModal = (props) => {
    const { competition_id, classItem, mode, onClick, nameOrMin, disabled } = props;
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState();
    const [form] = Form.useForm();
    const inputRef = useRef(null);
    const vendor = 'WDSF';
    const { notification } = App.useApp();
    const { settings, updateSettings } = useUserSettings();
    useEffect(() => {
        if (form) {
            form.resetFields();
        }
    }, []);
    useEffect(() => {
        setTimeout(() => {
            var _a;
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 50);
    }, [open]);
    const onFinish = (fieldsValue) => {
        setIsLoading(true);
        updateSettings({ externalApiHelper: btoa(JSON.stringify([fieldsValue['username'], fieldsValue['password']])) });
        fetchData(mode === 'sync' ? 'sync-api' : 'search-query-api', {
            type: fieldsValue['type'],
            class_id: classItem === null || classItem === void 0 ? void 0 : classItem.class_id
        }, {
            location: fieldsValue['location'],
            nameOrMin: fieldsValue['nameOrMin']
        })
            .then((result) => {
            setResult(result);
        });
        setIsLoading(false);
    };
    const fetchData = async (method, params, queries) => {
        var _a;
        try {
            return await Api.call(`${CompetitionSource.url}/${competition_id}`, method, {
                ...form.getFieldsValue(),
                ...params,
                queries
            });
        }
        catch (err) {
            const errorMessage = ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.message) || (err === null || err === void 0 ? void 0 : err.message) || "An unknown error occurred";
            notification.error({
                message: errorMessage
            });
            throw new Error(errorMessage);
        }
    };
    const handleCancel = () => {
        form.resetFields();
        setOpen(false);
    };
    const handleClick = (e) => {
        e.stopPropagation();
        setOpen(true);
    };
    const formName = 'external_api';
    const credentials = settings.externalApiHelper && JSON.parse(atob(settings.externalApiHelper));
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { key: "search-api", disabled: disabled, icon: React.createElement("img", { src: getAssetUrl(require('../../base-react/images/wdsf-icon.png')) }), onClick: handleClick }, ['sync', 'judges'].includes(mode) ? vendor : _T('common.search', { name: _T(mode + '.title').toLowerCase() + ' ' + vendor + ' API' })),
        React.createElement(Modal, { title: _T('common.search', { name: vendor + ' API' }), open: open, confirmLoading: isLoading, onCancel: handleCancel, width: 1000, footer: null },
            React.createElement(Form, { name: formName, labelCol: { span: 8 }, wrapperCol: { span: 16 }, form: form, disabled: isLoading || disabled, onFinish: (values) => onFinish(values), initialValues: {
                    username: credentials && credentials[0],
                    password: credentials && credentials[1],
                    debug: 0,
                    competitionId: classItem === null || classItem === void 0 ? void 0 : classItem.class_name,
                    type: mode === 'competition' ? 'competition' : 'person',
                    nameOrMin
                } },
                React.createElement(Form.Item, { label: "Username", name: "username", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Input, { "data-testid": "email", ref: inputRef, autoFocus: true, placeholder: `${vendor} username` })),
                React.createElement(Form.Item, { label: "Password", name: "password", rules: [{ required: true, message: _T('login.passwordInputMessage') }] },
                    React.createElement(Input.Password, { "data-testid": "password", autoComplete: 'current-password', placeholder: `${vendor} password` })),
                React.createElement(Form.Item, { label: "On Behalf Of", name: "onBehalfOf", hidden: mode != 'sync' },
                    React.createElement(Input, { "data-testid": "onBehalfOf" })),
                React.createElement(Form.Item, { name: "debug", label: "Sandbox Test", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: 0, key: 0 }, _T('common.disabled')),
                        React.createElement(Select.Option, { value: 1, key: 1 }, _T('common.enable')))),
                React.createElement(Form.Item, { label: "Competition ID", name: "competitionId", rules: [{ required: mode === 'sync', message: _T('common.required') }], hidden: mode != 'sync' },
                    React.createElement(Input, { "data-testid": "competitionId" })),
                React.createElement(Form.Item, { name: "type", label: _T('common.search'), rules: [{ required: true, message: _T('common.required') }], hidden: mode === 'sync' },
                    React.createElement(Select, null,
                        React.createElement(Select.Option, { value: "competition", key: "competition", disabled: mode != 'competition' }, "Competition/Class"),
                        React.createElement(Select.Option, { value: "couple", key: "couple", disabled: mode != 'team' }, "Couple"),
                        React.createElement(Select.Option, { value: "person", key: "person", disabled: mode != 'team' }, "Person"),
                        React.createElement(Select.Option, { value: "team", key: "team", disabled: mode != 'team' }, "Team"))),
                React.createElement(Form.Item, { label: _T('competition.details.competition_location.label'), name: "location", hidden: mode != 'competition' },
                    React.createElement(Input, { "data-testid": "location" })),
                React.createElement(Form.Item, { label: "Name Or Min", name: "nameOrMin", hidden: !['team', 'judges'].includes(mode) },
                    React.createElement(Input, { "data-testid": "nameOrMin" })),
                React.createElement(Form.Item, { wrapperCol: { offset: 8, span: 16 } },
                    React.createElement(Button, { type: "primary", htmlType: "submit", loading: isLoading, "data-testid": "submit" }, _T('common.search')))),
            classItem && mode === 'sync' ?
                React.createElement(SyncAPIResult, { competition_id: competition_id, classItem: classItem, data: result, loading: isLoading, fetchData: fetchData, vendor: vendor })
                :
                    React.createElement(ExternalAPIResult, { mode: mode, onClick: onClick, competition_id: competition_id, classItem: classItem, data: result, loading: isLoading, fetchData: fetchData }))));
};
export const ExternalAPIResult = (props) => {
    const { competition_id, classItem, mode, data, loading, fetchData, onClick } = props;
    const [classes, loadingClasses] = Stream(ClassesSource(competition_id));
    const { notification } = App.useApp();
    const recordAction = async (record, done) => {
        if (mode === 'competition') {
            const recordResult = await fetchData('verify-login-api', {
                competitionId: record.id
            }, {});
            const updateItem = {
                class_name: recordResult.id,
                class_label: `${recordResult.discipline} ${recordResult.danceform} ${recordResult.age}`
            };
            await Api.create(ClassesSource(competition_id).url, updateItem);
        }
        else if (mode === 'team' && classItem) {
            await fetchData('download-teams-api', {
                competitionId: classItem.class_name,
                team: record
            }, {});
        }
        if (onClick) {
            await onClick(record);
        }
        notification.success({
            message: _T('common.import.success', { name: _T(mode === 'competition' ? 'class.title' : mode + '.title').toLowerCase() })
        });
        done();
    };
    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            sorter: (a, b) => Number(a.id) - Number(b.id),
            defaultSortOrder: 'descend'
        },
        {
            title: _T('common.name'),
            dataIndex: 'name'
        },
        {
            key: 'action',
            render: (text, record) => React.createElement(ButtonConfirm, { title: _T('common.import.title'), description: _T('common.import.content', { name: _T(mode === 'competition' ? 'class.title' : mode + '.title').toLowerCase() }), onConfirm: (done) => recordAction(record, done), buttonProps: {
                    icon: React.createElement(FileAddOutlined, null),
                    disabled: classes === null || classes === void 0 ? void 0 : classes.map(a => a.class_name).includes(record.id.toString())
                } })
        }
    ].flat().filter(column => Object.keys(column).length > 0);
    return (React.createElement(React.Fragment, null,
        React.createElement(Table, { columns: columns, dataSource: data, bordered: false, pagination: false, loading: loading || loadingClasses, rowKey: "id" })));
};
const SyncAPIResult = (props) => {
    const { competition_id, classItem, data, loading, fetchData, vendor } = props;
    if (!data) {
        return null;
    }
    const items = [
        {
            key: '1',
            label: 'Competition Info',
            children: React.createElement(SyncAPIResultCompetition, { data: data, fetchData: fetchData })
        },
        {
            key: '2',
            label: 'Officials',
            children: React.createElement(SyncAPIResultOfficials, { data: data, fetchData: fetchData, vendor: vendor })
        },
        {
            key: '3',
            label: 'Teams',
            children: React.createElement(SyncAPIResultTeams, { classItem: classItem, data: data, fetchData: fetchData, vendor: vendor })
        },
    ];
    return React.createElement(Tabs, { items: items });
};
const SyncAPIResultCompetition = (props) => {
    const { data, fetchData } = props;
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState();
    if (!data) {
        return null;
    }
    const items = [
        {
            key: 'discipline',
            label: 'Discipline',
            children: data === null || data === void 0 ? void 0 : data.competition.discipline
        },
        {
            key: 'age',
            label: 'Age',
            children: data === null || data === void 0 ? void 0 : data.competition.age
        },
        {
            key: 'division',
            label: 'Division',
            children: data === null || data === void 0 ? void 0 : data.competition.division
        },
        {
            key: 'danceform',
            label: 'DanceForm',
            children: data === null || data === void 0 ? void 0 : data.competition.danceform
        },
        {
            key: 'type',
            label: 'Type',
            children: data === null || data === void 0 ? void 0 : data.competition.type
        },
        {
            key: 'country',
            label: 'Country',
            children: data === null || data === void 0 ? void 0 : data.competition.country
        },
        {
            key: 'date',
            label: 'Date',
            children: dayjs(data === null || data === void 0 ? void 0 : data.competition.date).format('LL')
        },
        {
            key: 'status',
            label: 'Status',
            children: data === null || data === void 0 ? void 0 : data.competition.status
        },
    ];
    const changeCompetitionStatus = async () => {
        setLoadingStatus(true);
        await fetchData('competition-api', {
            status: selectedStatus
        }, {});
        setLoadingStatus(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Descriptions, { items: items }),
        React.createElement(Title, { level: 5 }, "Status"),
        React.createElement(Space, null,
            React.createElement(Select, { defaultValue: data === null || data === void 0 ? void 0 : data.competition.status, loading: loadingStatus, style: { width: 400 }, onChange: setSelectedStatus, options: [
                    { value: 'PreRegistration', label: 'PreRegistration' },
                    { value: 'Registering', label: 'Registering' },
                    { value: 'RegistrationClosed', label: 'RegistrationClosed' },
                    { value: 'InProgress', label: 'InProgress' },
                    { value: 'Processing', label: 'Processing' },
                    { value: 'Closed', label: 'Closed' },
                    { value: 'Canceled', label: 'Canceled' },
                ] }),
            React.createElement(Button, { icon: React.createElement(UploadOutlined, null), onClick: changeCompetitionStatus, loading: loadingStatus }, "Set Competition Status")),
        React.createElement(Row, null,
            React.createElement("ul", null,
                React.createElement("li", null, "PreRegistration = The competition is not open for registrations yet"),
                React.createElement("li", null, "Registering = The competition is accepting registrations"),
                React.createElement("li", null, "RegistrationClosed = The competition has finished registration"),
                React.createElement("li", null, "InProgress = The competition is in progress"),
                React.createElement("li", null, "Processing = The competition results are available but not confirmed"),
                React.createElement("li", null, "Closed = The competition is finished and the results are confirmed"),
                React.createElement("li", null, "Canceled = The competition was cancelled")),
            React.createElement(Alert, { title: 'Once the status changes to "RegistrationClosed" or higher, the competition coefficient is calculated. Once the status changes to "Closed" the WRL points are calculated.' }))));
};
const SyncAPIResultTeams = (props) => {
    const { classItem, data, fetchData, vendor } = props;
    const [teams, loadingTeams] = Stream(ClassTeamSource(classItem.class_id));
    const [loadingTeam, setLoadingTeam] = useState();
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState({});
    const { notification } = App.useApp();
    if (!data) {
        return null;
    }
    const remoteItemsColumns = [
        {
            title: 'ID',
            dataIndex: 'id'
        },
        {
            title: _T('team.details.team_start_number.label'),
            dataIndex: 'number'
        },
        {
            title: _T('common.name'),
            key: 'name',
            render: (text, record) => React.createElement(Text, { disabled: !['Registered', 'Present'].includes(record.status), delete: !['Registered', 'Present'].includes(record.status) }, record.name || record.Team)
        },
        {
            title: _T('common.status'),
            dataIndex: 'status'
        },
        {
            title: _T('team.details.team_country.label'),
            key: 'country',
            render: (text, record) => record.country || record.TeamCountryXmlName
        },
        {
            key: 'action',
            render: (text, record) => React.createElement(Space, null,
                React.createElement(Button, { icon: React.createElement(DownloadOutlined, null), onClick: () => downloadRemoteTeam(record), loading: loadingTeam === record.id }),
                React.createElement(ButtonConfirm, { description: _T('common.delete.content', { name: _T('team.title').toLowerCase() }), onConfirm: (done) => recordAction(record, done), buttonProps: {
                        icon: React.createElement(DeleteOutlined, null),
                        size: "small"
                    } }))
        }
    ].flat().filter(column => Object.keys(column).length > 0);
    const recordAction = async (record, done) => {
        await fetchData('delete-team-api', {
            id: record.id
        }, {}).then(() => {
            notification.success({
                message: _T('common.delete.success', { name: _T('team.title').toLowerCase() })
            });
        }).catch(() => {
            done();
        });
        done();
    };
    const remoteTeamFooter = () => {
        return (React.createElement(Space, null,
            React.createElement(ButtonConfirm, { title: _T('common.import.title'), description: _T('common.import.content', { name: _T('team.title').toLowerCase() }), onConfirm: (done) => downloadRemoteTeams(done), buttonProps: {
                    icon: React.createElement(DownloadOutlined, null),
                    disabled: (data === null || data === void 0 ? void 0 : data.remoteTeams.length) === 0
                } })));
    };
    const downloadRemoteTeam = async (team) => {
        setLoadingTeam(team.id);
        await fetchData('download-teams-api', {
            competitionId: data === null || data === void 0 ? void 0 : data.competition.id,
            team
        }, {});
        setLoadingTeam(undefined);
    };
    const downloadRemoteTeams = async (done) => {
        await fetchData('download-teams-api', {
            competitionId: data === null || data === void 0 ? void 0 : data.competition.id
        }, {});
        done();
    };
    const localTeamFooter = () => {
        return (React.createElement(Space, null,
            React.createElement(ButtonConfirm, { title: _T('common.apply.title'), description: _T('common.apply.content', { name: _T('team.title').toLowerCase() }), onConfirm: (done) => uploadLocalTeams(done), buttonProps: {
                    icon: React.createElement(UploadOutlined, null),
                    disabled: !teams
                } })));
    };
    const uploadLocalTeams = async (done) => {
        setSuccess({});
        setErrors({});
        teams === null || teams === void 0 ? void 0 : teams.forEach(async (item, index) => {
            await uploadItem(item);
        });
        done();
    };
    const localItemsColumns = [
        {
            title: 'ID',
            dataIndex: 'team_warning'
        },
        {
            title: _T('team.details.team_start_number.label'),
            dataIndex: 'team_start_number'
        },
        {
            title: _T('common.name'),
            key: 'name',
            render: (text, record) => (React.createElement(Text, { disabled: record.team_cancelled, delete: record.team_cancelled }, TeamItem.getFullName(record)))
        },
        {
            title: _T('team.details.team_placement.label'),
            dataIndex: 'team_placement'
        },
        {
            title: _T('team.details.team_country.label'),
            dataIndex: 'team_country'
        },
        {
            key: 'response',
            render: (text, record) => ((errors === null || errors === void 0 ? void 0 : errors[record.team_id]) ? (React.createElement(Tooltip, { title: errors[record.team_id] },
                React.createElement(WarningOutlined, null))) : (success === null || success === void 0 ? void 0 : success[record.team_id]) ? (React.createElement(CheckOutlined, null)) : null)
        },
        {
            key: 'action',
            render: (text, record) => loadingTeam === record.team_id ? React.createElement(Spin, { size: "small" }) : React.createElement(Button, { icon: record.team_warning ? React.createElement(UploadOutlined, null) : React.createElement(UserAddOutlined, null), size: "small", onClick: () => uploadItem(record) })
        }
    ].flat().filter(column => Object.keys(column).length > 0);
    const uploadItem = async (record) => {
        setLoadingTeam(record.team_id);
        await fetchData('upload-team-api', {
            id: record.team_warning,
            class_id: record.class_id,
            team_id: record.team_id,
            exists: !!record.team_warning,
            type: record.team_url,
            coupleId: record.team_note,
            teamId: record.team_note,
            personId: record.team_note,
            number: record.team_start_number,
            rank: record.team_placement,
            status: (() => {
                var status = "";
                if (record.team_cancelled == 0) {
                    status = "Present";
                }
                if (record.team_cancelled > 0) {
                    status = "Withdrawn";
                }
                if (record.team_cancelled >= 2) {
                    status = "Excused";
                }
                if (record.team_cancelled == 5) {
                    status = "Noshow";
                }
                if (record.team_disqualified > 0) {
                    status = "Disqualified";
                }
                return status;
            })(),
            uploadMarks: true
        }, {})
            .catch((err) => {
            setErrors(existing => ({
                ...existing,
                [record.team_id]: err.message
            }));
        });
        setSuccess(existing => ({
            ...existing,
            [record.team_id]: true
        }));
        setLoadingTeam(undefined);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, { level: 3 }, vendor),
        React.createElement(Table, { columns: remoteItemsColumns, dataSource: data === null || data === void 0 ? void 0 : data.remoteTeams, bordered: false, pagination: false, loading: loadingTeams, footer: remoteTeamFooter, size: "small", rowKey: "id" }),
        React.createElement(Divider, null),
        React.createElement(Title, { level: 3 }, "Vote4Dance"),
        React.createElement(Table, { columns: localItemsColumns, dataSource: teams, bordered: false, pagination: false, loading: loadingTeams, footer: localTeamFooter, size: "small", rowKey: "team_id" })));
};
const SyncAPIResultOfficials = (props) => {
    const { data, fetchData, vendor } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(SyncAPIResultOfficialsList, { task: "Chairman", data: data, fetchData: fetchData, vendor: vendor }),
        React.createElement(Divider, null),
        React.createElement(SyncAPIResultOfficialsList, { task: "Adjudicator", data: data, fetchData: fetchData, vendor: vendor })));
};
const SyncAPIResultOfficialsList = (props) => {
    const { task, data, fetchData, vendor } = props;
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [selectedKey, setSelectedKey] = useState();
    if (!data) {
        return null;
    }
    const localItems = task === "Chairman" ? data === null || data === void 0 ? void 0 : data.localOfficials : data === null || data === void 0 ? void 0 : data.localJudges;
    const remoteItems = task === "Chairman" ? data === null || data === void 0 ? void 0 : data.remoteOfficials : data === null || data === void 0 ? void 0 : data.remoteJudges;
    const remoteItemsColumns = [
        {
            title: 'ID',
            dataIndex: 'Id'
        },
        {
            title: _T('common.name'),
            dataIndex: 'Name'
        },
        {
            title: _T('team.details.team_country.label'),
            dataIndex: 'country'
        },
        {
            key: 'action',
            render: (text, record) => React.createElement(ButtonConfirm, { description: _T('common.delete.content', { name: _T('judges.title').toLowerCase() }), onConfirm: (done) => recordAction(record, done), buttonProps: {
                    icon: React.createElement(DeleteOutlined, null),
                    size: "small"
                } })
        }
    ].flat().filter(column => Object.keys(column).length > 0);
    const recordAction = async (record, done) => {
        await fetchData('delete-official-api', {
            id: record.id || record.Id
        }, {});
        done();
    };
    const uploadItem = async () => {
        setLoadingStatus(true);
        const foundUser = localItems.find((a) => task === "Chairman" ? a.user_id === selectedKey : a.judge_id === selectedKey);
        if (foundUser) {
            await fetchData('add-official-api', {
                min: foundUser.team_refnr,
                task: task,
                letter: foundUser.judge_letter
            }, {});
        }
        setLoadingStatus(false);
    };
    const itemFooter = () => {
        return (React.createElement(Space, null,
            React.createElement(Select, { placeholder: `Select ${task} (Vote4Dance)`, loading: loadingStatus, style: { width: 400 }, onChange: setSelectedKey, options: localItems.map((a) => ({
                    value: a.user_id || a.judge_id,
                    label: UserCompetitionItem.getFullName(a) + (task === 'Adjudicator' ? (' - ' + a.judge_letter) : ''),
                    disabled: !a.team_refnr
                })), suffixIcon: true }),
            React.createElement(Button, { icon: React.createElement(UploadOutlined, null), onClick: uploadItem, loading: loadingStatus },
                "Upload as ",
                task)));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Title, { level: 3 },
            vendor,
            " ",
            task),
        React.createElement(Table, { columns: remoteItemsColumns, dataSource: remoteItems, bordered: false, pagination: false, footer: itemFooter, size: "small", rowKey: "Id" })));
};
